import { School } from '../../../types/school';
import { SchoolAuthorityDetail } from '../../../types/rest-api';

/** Visual theme for the Schulgemeinde / Schuleinheit top-left selector. */
export type NavbarEntitySwitcherVariant = 'surface' | 'primary';

export function resolveFallbackEntityName(
  authorities: SchoolAuthorityDetail[],
  schools: School[]
): string {
  return authorities[0]?.name ?? schools[0]?.name ?? '';
}

/** Label for the closed switcher when multiple entities exist (dropdown trigger). */
export function resolveSelectedEntityDisplayLabel(
  selectedEntityValue: string,
  authorities: SchoolAuthorityDetail[],
  schools: School[]
): string {
  const [type, id] = selectedEntityValue.split(':');
  if (type === 'authority') {
    const authority = authorities.find(a => a.id === id);
    return authority?.name ?? resolveFallbackEntityName(authorities, schools);
  }
  if (type === 'school') {
    const school = schools.find(s => s.id === id);
    return school?.name ?? resolveFallbackEntityName(authorities, schools);
  }
  return resolveFallbackEntityName(authorities, schools);
}

/** Label when only one entity exists (non-interactive chip). */
export function resolveSingleEntityDisplayName(
  authorities: SchoolAuthorityDetail[],
  schools: School[]
): string {
  return resolveFallbackEntityName(authorities, schools);
}
